if (!customElements.get('blog-grid')) {
    class BlogGrid extends HTMLElement {
        constructor() {
            super();

            this.elCategories = this.querySelectorAll('[data-category]');
            this.elPosts = this.querySelector('[data-posts]');

            this.elCategories.forEach(el => {
                el.classList.toggle('active', el.href == window.location.href);
                el.addEventListener('click', this.setCategory.bind(this))
            });
        }

        setCategory(ev) {
            ev.preventDefault();
            const elCategory = ev.currentTarget;

            this.elCategories.forEach(el => el.classList.remove('active'));
            elCategory.classList.add('active');

            this.classList.add('loading');
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

            this.fetchPosts(elCategory.href).then(elPosts => {
                this.elPosts.innerHTML = elPosts.innerHTML;
                setTimeout(() => {
                    this.classList.remove('loading');
                }, 300);
            });
        }

        async fetchPosts(url) {
            const response = await fetch(url);
            const data = await response.text();

            const html = new DOMParser().parseFromString(data, 'text/html');
            const elPosts = html.querySelector('[data-posts]');

            return elPosts;
        }
    }
    customElements.define('blog-grid', BlogGrid);
}